import React from 'react'
import { Box, Typography } from '@mui/material'
import { currencyFormatter } from '../../utils'
import { TooltipProps } from 'recharts'
import { PieValueType } from './ShopPieChart'
import { makeStyles } from 'tss-react/mui'

interface ShopPieChartCustomTooltipProps extends TooltipProps<number, string> {
  valueType: PieValueType
  filledValue: number
  tooltipFilledLabel: string
  tooltipUnfilledLabel: string
  filledColor: string
}

interface StylesProps {
  filledColor: string
}

const useStyles = makeStyles<StylesProps>()((theme, props) => ({
  tooltip: {
    backgroundColor: theme.palette.primary.contrastText,
    border: `1px solid ${props.filledColor}`,
    borderRadius: theme.shape.borderRadius,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
}))

/*
 * Component for custom tooltip in the shop pie chart.
 */
const ShopPieChartCustomTooltip: React.FC<ShopPieChartCustomTooltipProps> = ({
  active,
  payload,
  valueType,
  filledValue,
  tooltipFilledLabel,
  tooltipUnfilledLabel,
  filledColor,
}) => {
  const { classes } = useStyles({ filledColor })
  if (active && payload && payload.length) {
    const formattedValue = valueType === 'currency' ? currencyFormatter(payload[0].value) : payload[0].value
    const tooltipLabel = filledValue === payload[0].value ? formattedValue + ' ' + tooltipFilledLabel : formattedValue + ' ' + tooltipUnfilledLabel

    return (
      <Box className={classes.tooltip}>
        <Typography variant="caption">{tooltipLabel}</Typography>
      </Box>
    )
  }
  return null
}

export default ShopPieChartCustomTooltip
